class Masterconfig {
  constructor () {
    // Production server
    this.saved_link = 'http://cmt.onero.id/'
    // Development server
    // this.saved_link = 'http://cmdt.onero.id/'
    // Local Server
    // this.saved_link = 'http://localhost/connections-ministry/'
    // Local Storage Prefix
    this.ls_prefix = 'connections_ministry_'
    this.base_url = window.location.origin + '/'
    // this.base_url = window.location.origin + '/#/'
  }

  baseLink (extraLink = '') {
    return this.saved_link + extraLink
  }

  getLocalStoragePrefix () {
    return this.ls_prefix
  }

  getBaseUrl () {
    return this.base_url
  }
}

export default Masterconfig



// WEBPACK FOOTER //
// ./src/library/Masterconfig.js